import { render, staticRenderFns } from "./A15.vue?vue&type=template&id=5dbd111a&"
import script from "./A15.vue?vue&type=script&lang=ts&"
export * from "./A15.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports